import { FormattedMessage } from 'react-intl';
import type { PendingSchoolCardState } from '@/hooks/usePendingSchoolCard';

interface PendingCardBadgeProps {
  state: PendingSchoolCardState;
}

export const PendingCardBadge = ({ state }: PendingCardBadgeProps) => (
  <span className="inline-flex h-min max-w-full rounded bg-yellow-100 px-1.5 py-0.5 font-medium text-yellow-800">
    {state === 'awaiting-card-transfer' ? (
      <FormattedMessage defaultMessage="Flyttas från elevens tidigare organisation. Kortet visas här när överföringen är klar." />
    ) : (
      <FormattedMessage defaultMessage="Beställt. Väntar på att kortet skapas och levereras." />
    )}
  </span>
);
